var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrescreeningLeadsHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 13.9147C11.8995 13.0598 10.5091 12.55 9.00005 12.55C5.44621 12.55 2.55005 15.3771 2.55005 18.883C2.55005 19.0788 2.66864 19.1947 2.71566 19.2335C2.76759 19.2764 2.8173 19.298 2.83815 19.3066C2.88414 19.3254 2.92625 19.3344 2.94562 19.3383C2.99151 19.3475 3.0437 19.3537 3.09131 19.3583C3.19129 19.368 3.32972 19.3763 3.49562 19.3837C3.82999 19.3987 4.30363 19.4109 4.86724 19.4207C5.99578 19.4403 7.49859 19.45 9.00005 19.45C10.4433 19.45 11.8879 19.441 13 19.4229V18.5228C11.8926 18.541 10.447 18.55 9.00005 18.55C7.50151 18.55 6.00432 18.5403 4.88285 18.5208C4.32147 18.5111 3.85761 18.499 3.53572 18.4846L3.46501 18.4813C3.67482 15.6754 6.0652 13.45 9.00005 13.45C10.5741 13.45 11.9916 14.0902 13 15.1167V13.9147Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00005 5.44999C7.59172 5.44999 6.45005 6.59166 6.45005 7.99999C6.45005 9.40831 7.59172 10.55 9.00005 10.55C10.4084 10.55 11.55 9.40831 11.55 7.99999C11.55 6.59166 10.4084 5.44999 9.00005 5.44999ZM5.55005 7.99999C5.55005 6.09461 7.09467 4.54999 9.00005 4.54999C10.9054 4.54999 12.45 6.09461 12.45 7.99999C12.45 9.90537 10.9054 11.45 9.00005 11.45C7.09467 11.45 5.55005 9.90537 5.55005 7.99999Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 6.99998H15V6.09998H23V6.99998Z",
    fill: "#2D2943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 9.99998H15V9.09998H23V9.99998Z",
    fill: "#2D2943"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12.4525L15.45 14.0327V17.6024C15.45 19.5307 16.509 20.9878 17.6438 21.9967C18.7324 22.9644 19.8454 23.477 20.0009 23.5457C20.169 23.4709 21.2748 22.9584 22.3563 21.9968C23.4911 20.9878 24.55 19.5307 24.55 17.6024V14.0327L20 12.4525ZM20.2813 11.5975C20.099 11.5339 19.9009 11.5345 19.7195 11.5972L15.1358 13.1891C14.7803 13.3133 14.55 13.6519 14.55 14.0205V17.6024C14.55 19.8895 15.8111 21.5715 17.0459 22.6693C18.2711 23.7586 19.5191 24.3181 19.6582 24.378C19.7687 24.4269 19.8853 24.45 20 24.45C20.1159 24.45 20.2316 24.4265 20.3399 24.3798C20.46 24.3279 21.7187 23.7679 22.9543 22.6694C24.189 21.5715 25.45 19.8895 25.45 17.6024V14.0205C25.45 13.6521 25.2215 13.3124 24.8638 13.1889C24.864 13.189 24.8636 13.1888 24.8638 13.1889L20.2813 11.5975C20.2815 11.5976 20.2811 11.5974 20.2813 11.5975Z",
    fill: "#2D2943"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8183 16.8182L19.5001 20.1364L16.6819 17.3182L17.3183 16.6818L19.5001 18.8636L22.1819 16.1818L22.8183 16.8182Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescreeningLeadsHover);
export default __webpack_public_path__ + "static/media/prescreening-leads-hover.70524ba1.svg";
export { ForwardRef as ReactComponent };